<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <TextFieldInput :label="$t('ELE0026')" v-model="searchCondition.measInstCd" />
          </v-col>
          <v-col cols="4">
            <TextFieldInput :label="$t('ELE0027')" v-model="searchCondition.measInstName" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <span class="d-flex flex-row space-between mr-4">
              <Checkbox :label="$t('ELE0022')" v-model="searchCondition.validOnly" />
              <v-spacer />
              <BtnSearch class="mt-2" @click="onClickSearch" />
            </span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-card outlined>
              <v-card-title class="pt-1 pb-0">
                {{ $t('ELE0023') }}
                <v-spacer />
                <BtnAdd @click="addItem" />
              </v-card-title>
              <v-data-table :headers="headers" :items="items" dense>
                <template v-slot:[`item.action`]="{ item }">
                  <IconInquiry @click="inquiryItem(item)" left />
                  <IconEdit @click="editItem(item)" right />
                </template>
                <template v-slot:[`item.isValid`]="{ item }">
                  {{ $t('isValid.' + item.isValid) }}
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-container>
    <MeasInstDialog
      v-if="item !== null"
      :dialog.sync="dialog"
      :mode="mode"
      :measInstCd.sync="item.measInstCd"
      :measInstName.sync="item.measInstName"
      :isValid.sync="item.isValid"
      :versionNo.sync="item.versionNo"
      @change="onClickSearch()"
    />
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import { ModalMode } from '@/enum'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import cloneDeep from 'lodash/cloneDeep'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import Btn from '@/components/atoms/base/button/Btn'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnAdd from '@/components/atoms/button/BtnAdd'
import IconEdit from '@/components/atoms/icon/IconEdit'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import MeasInstDialog from '@/components/organisms/master/dialog/MeasInstDialog'

export default {
  name: 'MeasInstMachine',
  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    TextFieldInput,
    Btn,
    Checkbox,
    MeasInstDialog,
    BtnSearch,
    BtnAdd,
    IconEdit,
    IconInquiry,
  },

  data() {
    return {
      dialog: false,
      mode: '',
      searchCondition: {
        measInstCd: '',
        measInstName: '',
        validOnly: true,
      },
      items: [],
      item: null,
      headers: [
        { text: '', align: 'start', divider: true, width: '90', sortable: false, value: 'action' },
        { text: this.$t('ELE0026'), divider: true, value: 'measInstCd' },
        { text: this.$t('ELE0027'), divider: true, value: 'measInstName' },
        { text: this.$t('ELE0014'), divider: true, value: 'isValid' },
        { text: this.$t('ELE0029'), divider: true, value: 'itemUpdatedBy' },
        { text: this.$t('ELE0039'), divider: true, value: 'updaterUserName' },
        { text: this.$t('ELE0030'), divider: false, value: 'editItemUpdatedAt' },
      ],
      emptyItem: {
        measInstCd: '',
        measInstName: '',
        isValid: true,
        versionNo: 0,
      },
    }
  },

  methods: {
    addItem() {
      this.mode = ModalMode.ADD
      this.item = cloneDeep(this.emptyItem)
      this.dialog = true
    },
    editItem(item) {
      this.mode = ModalMode.EDIT
      this.item = cloneDeep(item)
      this.dialog = true
    },
    inquiryItem(item) {
      this.mode = ModalMode.INQUIRY
      this.item = cloneDeep(item)
      this.dialog = true
    },
    async onClickSearch() {
      this.startLoading()

      try {
        const params = {
          measInstCd: this.searchCondition.measInstCd,
          measInstName: this.searchCondition.measInstName,
          validOnly: this.searchCondition.validOnly,
        }

        this.items = []

        const elements = await API.get('/master/measInsts', params)
        elements.forEach((element) => {
          element['editItemUpdatedAt'] = this.toLocalTime(element['itemUpdatedAt'])
          element['updaterUserName'] = element['m_user']['userName']
          this.items.push(element)
        })
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0025') })))
      } finally {
        this.stopLoading()
      }
    },
  },
  mounted() {
    this.onClickSearch()
  },
}
</script>
